import { Toro } from '../../common/enumerations';

export class IrrigationControllerResyncRecordsNotification
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Handle any custom mappings here
        }
    }

    ControllerId: number;
    MessageId: string;
    TypeCode: Toro.NotificationTypeCode = 0;
    WasConfigurationSuccessfullyDelivered = false;
}
